const frontendURL = '/cat/user/';
const backendURL = '/api/auth/profile/';
// const backendURL = '/api/auth/user/';
const name = 'Користувачі';

const instance = {
  frontendURL,
  backendURL,
  name,
};
export default instance;
